<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-05-22 14:55:12
 * @LastEditTime: 2019-05-22 14:55:12
 * @LastEditors: your name
 -->
<template>
  <div>
    <el-form :inline="true">
      <el-form-item v-if="isVisible('type')">
        <el-select v-model="type" @change="changeType">
          <el-option
            v-for="item in typeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="isVisible('type') && type === 'appId'">
        <el-select v-model="appId" placeholder="请选择媒体" clearable filterable @change="changeAppId">
          <el-option
            v-for="item in appIdOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="isVisible('type') && type === 'pageId'">
        <el-select v-model="pageId" placeholder="请选择页面" clearable filterable @change="changePageId">
          <el-option
            v-for="item in pageIdOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="valDateRange"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
          @change="changeDateRange">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="showCharts">刷新</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import moment,{ months } from "moment";
import axios from "axios";
import qs from "qs";

export default {
  props: ['showCharts', 'disabled'],
  data() {
    const self = this;
    return {
      appIdOptions: [],
      pageIdOptions: [],
      typeOptions: [{
        label: '媒体',
        value: 'appId'
      }, {
        label: '页面',
        value: 'pageId'
      }],
      pickerOptions: {
        shortcuts: [{
          text: '昨天',
          onClick(picker) {
            const { end, start } = self.getStartEnd(1);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '前三日',
          onClick(picker) {
            const { end, start } = self.getStartEnd(3);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '前七日',
          onClick(picker) {
            const { end, start } = self.getStartEnd(7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '一个月',
          onClick(picker) {
            const { end, start } = self.getStartEnd(30);
            picker.$emit('pick', [start, end]);
          }
        }],
        disabledDate (time) {
          // 设置选择的日期小于当前的日期,小于返回true,日期不可选
          return time.getTime() > Date.now() - 8.64e7
        },
      },
      value7: '',
      clientType: '',
      type: 'pageId',
      appId: '',
      pageId: '',
      valDateRange: ''
    };
  },
  mounted() {
    const { end, start } = this.getStartEnd(7);
    this.valDateRange = [start, end];

    this.$bus.$on("clientChange", val => {
      this.clientType = val;
      this.init();
    });

    if (this.$bus.DATA.clientType) {
      this.clientType = this.$bus.DATA.clientType;
      this.init();
    }
  },
  methods: {
    init() {
      this.appId = '';
      this.pageId = '';
      this.fetchAppIds();
      this.fetchPageIds();

      this.$emit('update:params', {
        clientType: this.clientType,
        start: this.valDateRange[0],
        end: this.valDateRange[1],
        type: this.type,
        [this.type]: this[this.type]
      });

      this.showCharts();
    },
    fetchPageIds() {
      const { start, end } = this.getStartEnd(7);
      const query = {
        client: this.clientType,
        start: this.start || start,
        end: this.end || end
      };

      return axios
        .get(`/history/pageIds?${qs.stringify(query)}`)
        .then(response => {
          const { data } = response.data;
          const arr = [];
          data.map(item => {
            arr.push({
              label: item.page_id,
              value: item.page_id
            });
          });
          this.pageIdOptions = [{
            label: '全部页面',
            value: ''
          }].concat(arr);
        })
    },
    fetchAppIds() {
      const { start, end } = this.getStartEnd(7);
      const query = {
        client: this.clientType,
        start: this.start || start,
        end: this.end || end
      };

      return axios
        .get(`/history/appIds?${qs.stringify(query)}`)
        .then(response => {
          const { data } = response.data;
          const arr = [];
          data.map(item => {
            arr.push({
              label: `${item.app_id}`,
              value: `${item.app_id}`
            });
          });
          this.appIdOptions = [{
            label: '全部媒体',
            value: ''
          }].concat(arr);
        })
    },
    changeType(type) {
      this.$emit('update:params', {
        clientType: this.clientType,
        start: this.valDateRange[0],
        end: this.valDateRange[1],
        type,
        [type]: ''
      });

      this.clear();

      this.showCharts();
    },
    changeAppId(appId) {
      this.$emit('update:params', {
        clientType: this.clientType,
        start: this.valDateRange[0],
        end: this.valDateRange[1],
        type: this.type,
        appId
      });

      this.clear('appId');

      this.showCharts();
    },
    setAppId(appId) {
      this.appId = appId;
      this.changeAppId(appId)
    },
    changePageId(pageId) {
      this.$emit('update:params', {
        clientType: this.clientType,
        start: this.valDateRange[0],
        end: this.valDateRange[1],
        type: this.type,
        pageId
      });
      this.clear('pageId');
      this.showCharts();
    },
    setPageId(pageId) {
      this.pageId = pageId;
      this.changePageId(pageId)
    },
    clear(cur) {
      this.typeOptions.map(type => {
        if (type !== cur) {
          this[type] = '';
        }
      })
    },
    getStartEnd(daynum) {
      const end = new Date();
      const start = new Date();
      end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
      start.setTime(start.getTime() - 3600 * 1000 * 24 * daynum);
      return {
        end,
        start
      }
    },
    changeDateRange(dateRange) {
      this.$emit('update:params', {
        clientType: this.clientType,
        start: dateRange[0],
        end: dateRange[1],
        type: this.type,
        [this.type]: this[this.type]
      });
      this.showCharts();
    },
    isVisible(name) {
      return !this.disabled || (this.disabled && this.disabled.indexOf(name) === -1);
    }
  }
}
</script>
